<template>
  <b-dropdown id="maincompanypicker_web_maincompanypicker" variant="link" class="header-company-dropdown ui-dashboard-menu-dropdown" no-caret>
    <template #button-content>
      <span class="fullname">{{ companyName }}</span>
      <font-awesome-icon icon="fa-solid fa-caret-down" />
      <span class="userarea">{{ currentUser.display_name }} {{ userStatus }} </span>
    </template>
    <b-dropdown-form form-class="form-style">
      <b-form-group @submit.stop.prevent class="dropdown-fullname">
        <div class="d-flex w-100">
          <Avatar :userId="currentUser.id" />
          <div class="name-status">
            <span class="fullname w-100">{{ currentUser.display_name }}</span>
            <span v-if="isAccountant" class="premium-text" :key="isAccountant" v-translate>ACCOUNTANT</span>
            <span v-else-if="is_premium" class="premium-text" :key="is_premium" v-translate>PREMIUM</span>
            <span v-else class="basic-text" v-translate>BASIC</span>
          </div>
        </div>
      </b-form-group>

      <div v-if="companyList && companyList.length > 0" class="switch-to">{{ $gettext('My Companies') }}</div>
      <overlay-scrollbars
        v-if="companyList && companyList.length > 0"
        :options="{ scrollbars: { autoHide: 'never' }, overflowBehavior: { y: 'scroll', x: 'hidden' } }"
      >
        <b-dropdown-item
          v-for="company in companyList"
          class="company-dropdown-switch"
          :class="{ current: (currentCompany.id === company.id)}"
          href="#"
          :key="company.id"
          @click="redirect(company)"
        >
          <span class="border"></span><span class="tick">-</span>
          <font-awesome-icon v-if="company.id == currentUser.default_company" icon="fa-solid fa-home" />
          <font-awesome-icon v-else-if="company.is_premium" icon="fa-solid fa-lock-open" />
          <font-awesome-icon v-else icon="fa-solid fa-lock" />
          {{ company.name }}
        </b-dropdown-item>
      </overlay-scrollbars>

      <b-dropdown-item
        class="company-dropdown-switch add-switch margin-0 text-blue"
        :href="Urls['accounts_add_company']()"
      >
        <font-awesome-icon icon="fa-solid fa-plus" class="text-blue" /><span v-translate class="text-blue">Add new company</span>
      </b-dropdown-item>

      <div v-if="sharedCompanyList && sharedCompanyList.length > 0" class="switch-to">
        {{ $gettext('Connected companies') }}
      </div>
      <overlay-scrollbars
        v-if="sharedCompanyList && sharedCompanyList.length > 0"
        :options="{ scrollbars: { autoHide: 'never' }, overflowBehavior: { y: 'scroll', x: 'hidden' } }"
      >
        <b-dropdown-item
          v-for="company in sharedCompanyList"
          class="company-dropdown-switch"
          :class="{ current: (currentCompany.id === company.id)}"
          href="#"
          :key="company.id"
          @click="redirect(company, true)"
        >
          <span class="border"></span><span class="tick">-</span>
          <font-awesome-icon v-if="company.is_active" icon="fa-solid fa-lock-open" />
          <font-awesome-icon v-if="!company.is_active" icon="fa-solid fa-lock" />
          {{ company.name }}
        </b-dropdown-item>
      </overlay-scrollbars>

      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item class="redirect-option" :href="Urls['accounts_team_settings']()"
        ><font-awesome-icon icon="fa-solid fa-users" /><span v-translate>Team</span></b-dropdown-item
      >
      <b-dropdown-item v-if="!currentUser.is_accountant" class="redirect-option" :href="Urls['accounts_edit_profile']()"
        ><font-awesome-icon icon="fa-solid fa-gear" /><span v-translate>Settings</span></b-dropdown-item
      >
      <b-dropdown-item
        v-if="currentUser.is_accountant && currentCompany.has_accountant"
        class="redirect-option"
        :href="Urls['accounts_manage_companies']()"
        ><font-awesome-icon icon="fa-solid fa-gear" /><span v-translate>Settings</span></b-dropdown-item
      >
      <b-dropdown-item class="redirect-option" :href="Urls['subscriptions:manage']()"
        ><font-awesome-icon icon="fa-solid fa-euro-sign" /><span v-translate>My Subscriptions</span></b-dropdown-item
      >
      <b-dropdown-item class="redirect-option" :to="{ name: 'TaxreportList' }"
        ><font-awesome-icon icon="fa-solid fa-database" /><span v-translate>VAT report</span></b-dropdown-item
      >
      <b-dropdown-divider v-if="is_staff"></b-dropdown-divider>
      <b-dropdown-item v-if="is_staff" class="redirect-option" :href="'/tokeh'"
        ><font-awesome-icon icon="fa-solid fa-gears" /><span v-translate>Admin</span></b-dropdown-item
      >
      <b-dropdown-divider></b-dropdown-divider>
      <!-- <b-dropdown-item class="redirect-option" :href="Urls['accounts_logout']()"><font-awesome-icon icon="fa-solid fa-power-off" /><span v-translate>Logout Django</span></b-dropdown-item> -->
      <b-dropdown-item class="redirect-option" :to="{ name: 'Logout' }"
        ><font-awesome-icon icon="fa-solid fa-power-off" /><span v-translate>Logout</span></b-dropdown-item
      >
    </b-dropdown-form>
  </b-dropdown>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Avatar from '@/components/Avatar'

export default {
  name: 'MainCompanyPicker',
  components: { Avatar },
  props: {
    isAccountant: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
      currentUser: 'main/getCurrentUser',
      companyList: 'main/getCompanyList',
      sharedCompanyList: 'main/getSharedCompanyList',
      is_staff: 'main/getIsStaff',
      preferredLanguage: 'main/getPreferredLanguage',
    }),
    companyName() {
      return this.currentCompany.name
    },
    userStatus() {
      let user_status = this.is_premium ? '| ' + this.$gettext('PREMIUM') : ''
      if (this.isAccountant) {
        user_status = '| ' + this.$gettext('ACCOUNTANT')
      }
      return user_status
    },
    is_premium() {
      return this.currentUser.is_premium
    },
  },
  watch: {
    companyName(newName, oldName) {
      let company = this.companyList.find((company) => company.name === oldName)
      if (company) {
        company.name = newName
      }
    },
  },
  created() {
    this.loadUserCompanies()
  },
  methods: {
    ...mapActions({
      loadUserCompanies: 'main/loadUserCompanies',
      switchCompany: 'main/switchCompanyProfile',
      switchToVisitingCompany: 'main/switchToVisitingCompany',
    }),

    redirect(targetCompany, isConnected = false) {
      if (!targetCompany || targetCompany.id == null) {
        // avoid crashes if called incorrectly
        return
      }
      if (this.currentCompany.id === targetCompany.id) {
        // if already on that company do nothing
        return
      }

      // Assuming you can only access a connected company if it’s on a premium plan with team member slots, or if you’re its accountant
      const canAccess = isConnected
        ? (this.isAccountant || !!targetCompany.is_premium)
        : !!this.currentCompany.is_premium
      if (!canAccess) {
        // Accountants trying to access their own company will be redirected to accountants portal
        if (this.isAccountant && targetCompany.id === this.currentUser.default_company) {
          window.location.href = `/${this.preferredLanguage}/accountants/clients/`
          return
        }
        this.showSwitchPremiumTrigger(isConnected)
        return
      }

      const shouldShowPremiumTrigger =
        !this.isAccountant &&
        !this.currentUser.is_premium &&
        !targetCompany.is_premium &&
        targetCompany.id !== this.currentUser.default_company

      if (shouldShowPremiumTrigger) {
        this.showSwitchPremiumTrigger()
        return
      }
      if (this.isAccountant) {
        this.switchToVisitingCompany(targetCompany.id)
      } else {
        this.switchCompany(targetCompany.id)
      }
    },

    showSwitchPremiumTrigger(isConnected) {
      let alert_txt = this.$gettext('You no longer have access to additional company profiles you own. Please upgrade to Premium to regain access.')
      let alert_title = this.$gettext('Premium subscription required')
      if (isConnected) {
        alert_txt = this.$gettext("This connected company can't be accessed right now.")
        alert_title = this.$gettext('Company connection issue')
      }
      this.$store.commit('setAlert', {
        title: alert_title,
        text: alert_txt,
        variant: 'warning',
        duration: 6,
      })
    },
  },
}
</script>

<style lang="scss">
.header-company-dropdown {
  margin-left: 5px;
  .os-host {
    display: flex;
    min-height: 30px;
  }
  &--my_companies .os-host,
  &--shared_companies .os-host {
    height: 100%;
  }
  .dropdown-toggle {
    display: grid;
    flex-direction: column;
    padding: 0;
    margin-right: 10px;
    text-decoration: none !important;
    &:hover {
      text-decoration: none !important;
    }
    &:focus,
    &:focus-visible {
      outline: none !important;
    }
  }
  .dropdown-menu {
    max-width: 300px;
    z-index: 1001;
    &.show {
      display: flex;
    }
    > li {
      display: flex;
      width: 100%;
    }
    @media (max-width: '767px') {
      max-width: 240px;
    }

    max-height: calc(100vh - 65px);

    .form-style {
      padding: 0;
      display: flex;
      flex-direction: column;
    }
  }

  .dropdown-item {
    display: block !important;
    border-radius: 0 !important;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .basic-text {
    color: #bbbbbb;
  }
  .premium-text {
    color: #ffbb00;
  }
  .basic-text,
  .premium-text {
    font-size: 12px;
    display: block;
  }
  .switch-to {
    color: #bbbbbb;
    font-size: 14px;
    z-index: 999999;
    background: #ffffff;
    padding-left: 10px;
    margin-top: 0.5rem;
  }
  .dropdown-menu {
    padding: 10px 0px;
    font-size: 14px;
    min-width: 230px !important;
    // min-height: 365px;
    .fullname {
      width: 100%;
      font-size: 20px;
      color: $colorTextBase;
      line-height: 1.2;
      display: block;
    }
    .dropdown-fullname {
      padding: 0px 10px;
      margin-bottom: 0;
    }
    .company-dropdown-switch {
      cursor: pointer;
      padding: 4px 0px;
      position: relative;
      .dropdown-item {
        color: #777;
        border-width: 2px;
        padding: 0px 20px;
        margin-left: 1px;
      }
      &.selected {
        .dropdown-item {
          color: $colorTextBase;
        }
      }
      &.add-switch {
        .dropdown-item {
          border-left: 0px;
          padding-left: 26px;
        }
      }
      span.border {
        background-color: lightgray;
        height: 30px;
        width: 1.5px;
        top: -14.8px;
        position: absolute;
        z-index: -1;
      }
      span.tick {
        color: lightgray;
      }
    }

    .redirect-option {
      &:hover {
        margin-left: -2px;
      }
      .dropdown-item {
        color: $colorTextBase;
        border-width: 2px;
        padding: 4px 20px;
        margin-left: 1px;
        &:hover {
          border-left: 2px solid #eb8d36;
        }
      }
    }
    .company-dropdown-switch:not(.add-switch) {
      &.current {
        cursor: initial;
        a {
          cursor: initial;
          color: $colorBrand;
        }
      }
    }
    .company-dropdown-switch:not(.add-switch):not(.current):hover,
    .redirect-option:hover {
      .dropdown-item {
        color: #eb8d36;
      }
    }
    .dropdown-item:hover {
      background: transparent;
    }
  }
  .profile-badge {
    font-size: 16px;
    .no-avatar {
      color: #666;
      margin-top: 3px;
      width: 36px;
      height: 36px;
      display: inline-block;
      padding: 6px 0;
      background: #ddd;
      margin-right: 5px;
      border-radius: 20px;
      float: left;
      text-align: center;
    }
  }
  .dropdown-divider {
    border-color: #dddddd;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>

<style lang="scss" scoped>
</style>